import React, { useState, useEffect } from 'react';
import { debounce } from 'lodash';

/**
 * Gets the width and height of the element based on the passed ref. Updates on resize
 * @param myRef ref of element to use
 * @param debounceTime wait time to debounce on resize
 * @returns width and height of element
 */
export function useContainerDimensions(myRef: React.RefObject<HTMLElement>, debounceTime = 100) {
    const [dimensions, setDimensions] = useState({ width: 0, height: 0 });

    useEffect(() => {
        const getDimensions = () => ({
            width: (myRef.current && myRef.current.offsetWidth) || 0,
            height: (myRef.current && myRef.current.offsetHeight) || 0,
        });

        const handleResize = debounce(() => {
            setDimensions(getDimensions());
        }, debounceTime);

        if (myRef.current) {
            setDimensions(getDimensions());
        }

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, [myRef, debounceTime]);

    return dimensions;
}
